import { ReactNode, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getMe } from '../lib/api';

export default function AuthGate({ children }: { children: ReactNode }) {
  const loc = useLocation();
  const [ok, setOk] = useState<boolean | null>(null);
  useEffect(() => {
    getMe().then((u) => setOk(!!u)).catch(() => setOk(false));
  }, [loc.pathname]);
  if (ok === null) return <p className="muted">载入中…</p>;
  if (!ok) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <>{children}</>;
}
